module.exports = __webpack_public_path__ + "static/image/font/pc/visual.jpg?6ae1f070";